import React from 'react';
import * as Indicadores from '../constantes/IndicadoresMovimientosEquipos.js';
import * as Iconos from './Iconos.js';
import styles from './Iconos.module.css';

export const IconoMovimiento = (props) => {
  const objeto = props.objeto;

  let source = null;
  let alt = null;
  if (objeto && objeto.movimientoDivisional) {
    if (objeto.movimientoDivisional === Indicadores.ASCENSO) {
      source = Iconos.ascenso;
      alt = 'Ascendió';
    } else if (objeto.movimientoDivisional === Indicadores.ASCENSO_X_PROMEDIO) {
      source = Iconos.ascensoPromedio;
      alt = 'Ascendió por promedio';
    } else if (objeto.movimientoDivisional === Indicadores.DESCENSO) {
      source = Iconos.descenso;
      alt = 'Descendió';
    } else if (objeto.movimientoDivisional === Indicadores.DESCENSO_X_PROMEDIO) {
      source = Iconos.descensoPromedio;
      alt = 'Descendió por promedio';
    }
  }

  return (
    <React.Fragment>
      {source && (
        <img
          className={`${styles.iconoMovimiento}`}
          src={source}
          id={objeto.id}
          key={alt + objeto.id}
          alt={alt}
        />
      )}
    </React.Fragment>
  );
};

export default IconoMovimiento;
